<template>

  <b-row class="m-md-5 m-lg-5">
    <b-col lg="12">
      <hr>
      <h2
        class="text-center m-5 mx-sm-0"
      >
        Temas de interés
      </h2>
      <b-tabs
        justified
        pills
        class="m-md-5 m-lg-5"
      >
        <b-tab
          title="Calendario Escolar"
          active
        >
          <calendario />
        </b-tab>
        <b-tab title="Biblioteca">
          <div class="text-center mt-3">
            <b-button
              variant="primary"
              class="mb-3 btn-sm-block"
              href="https://www.indetec.gob.mx/biblioteca.php"
            >
              Biblioteca de Indetec
            </b-button>
          </div>
        </b-tab>
        <b-tab title="Archivos para descargar">
          Zona en construcción
        </b-tab>
      </b-tabs>
      <hr>
    </b-col>
  </b-row>
</template>
<script>
import {
  BRow, BCol, BTabs, BTab, BButton,
} from 'bootstrap-vue'
import calendario from './calendario.vue'

export default {
  components: {
    calendario,
    BRow,
    BCol,
    BTabs,
    BTab,
    BButton,
  },
}
</script>
